/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { sendSmsRequestRequestSchema } from "./sendSmsRequestRequestSchema.ts";
import { sendSmsRequestSchema } from "./sendSmsRequestSchema.ts";

export const userSendSmsCreateStatus200Schema = sendSmsRequestSchema.describe("Сериализатор запроса на отправку SMS.");

export const userSendSmsCreateResponseSchema = userSendSmsCreateStatus200Schema;

export const userSendSmsCreateDataSchemaJson = sendSmsRequestRequestSchema.describe("Сериализатор запроса на отправку SMS.");

export const userSendSmsCreateDataSchemaXml = sendSmsRequestRequestSchema.describe("Сериализатор запроса на отправку SMS.");

export const userSendSmsCreateDataSchema = z.union([userSendSmsCreateDataSchemaJson, userSendSmsCreateDataSchemaXml]);
